// Login
export const FETCH_LOGIN_REQUEST = "FETCH_LOGIN_REQUEST"
export const FETCH_LOGIN_SUCCESS = "FETCH_LOGIN_SUCCESS"
export const FETCH_LOGIN_FAIL = "FETCH_LOGIN_FAIL"
export const FETCH_EDIT_REQUEST="FETCH_EDIT_REQUEST"
export const  FETCH_EDIT_SUCCESS="FETCH_EDIT_SUCCESS"
export const  FETCH_EDIT_FAIL="FETCH_EDIT_FAIL"

// Logout
export const FETCH_LOGOUT_REQUEST = "FETCH_LOGOUT_REQUEST"

// Language
export const FETCH_LANGUAGE_REQUEST = " FETCH_LANGUAGE_REQUEST"
export const FETCH_LANGUAGE_SUCCESS = " FETCH_LANGUAGE_SUCCESS"
export const FETCH_LANGUAGE_FAIL = " FETCH_LANGUAGE_FAIL"

//Forget Password
export const BACK="BACK"
export const FETCH_FORGET_REQUEST = "FETCH_FORGET_REQUEST"
export const FETCH_FORGET_SUCCESS = "FETCH_FORGET_SUCCESS"
export const FETCH_FORGET_FAIL = "FETCH_FORGET_FAIL"

export const FETCH_CONFIRMATIONCODE_REQUEST = "FETCH_CONFIRMATIONCODE_REQUEST"
export const FETCH_CONFIRMATIONCODE_SUCCESS = "FETCH_CONFIRMATIONCODE_SUCCESS"
export const FETCH_CONFIRMATIONCODE_FAIL = "FETCH_CONFIRMATIONCODE_FAIL"


export const FETCH_RESETPASSWORD_REQUEST = "FETCH_RESETPASSWORD_REQUEST"
export const FETCH_RESETPASSWORD_SUCCESS = "FETCH_RESETPASSWORD_SUCCESS"
export const FETCH_RESETPASSWORD_FAIL = "FETCH_RESETPASSWORD_FAIL"

// Initialize USER
export const REINTIALIZE = "REINTIALIZE"

// Side Menu
export const SIDEMENUSTATUS = "SIDEMENUSTATUS"

// LAYOUT SETTING
export const COLORLAYOUT="COLORLAYOUT"
export const COLORSIDEMENU="COLORSIDEMENU"
export const BGSIDEMENU="BGSIDEMENU"
// Sub Header
export const SUBHEADER = "SUBHEADER"





